import { privateRequest, publicRequest } from "@/services/axios";

const GetSupplierDashboardData = async () => {
    try {
        const res = await privateRequest.get("/api/Dashboard");
        return res.data;
    } catch (err: any) {
        return err.response;
    }
};

const DashboardService = {
    GetSupplierDashboardData,
};

export default DashboardService;
